import axios from 'axios'
import {router} from '@/router';
import notification from 'ant-design-vue/es/notification'
import {encrypt} from './RsaUtils1'
import {getToken,setToken} from '@/utils/sessionUtils'

import settings from '../../settings'

const isCrypt = settings.isCrypt;
const isDebug = settings.isDebug;
const instance = axios.create({timeout: 1000 * 300});

instance.interceptors.request.use(
    config => {
        const token = getToken();
        if (token === null) {
            if (!isDebug) {
                if (config.url.startsWith('/api')) {
                    //console.log('axios重定向拦截,isDebug:', isDebug)
                    router.push('/login')
                }
            }
        }
        config.headers['crabapples-token'] = token;
        config.data = isCrypt && config.data ? encrypt(JSON.stringify(config.data)) : config.data
        if (/get/i.test(config.method)) {
            config.params = config.params || {}
            config.params.temp = Date.parse(new Date()) / 1000
            if (!!config.params.pageIndex) {
                config.params.pageIndex--
            }
        }
        return config;
    },
    error => Promise.error(error)
);

// 响应拦截器
instance.interceptors.response.use(
    response => {
        if (!isDebug){
        	//console.warn('响应拦截->success', response);
        }
        let data = response.data
        if (response.data.status === 401) {
            notification.error({message: '登录已过期，请重新登录'});
            setToken('')
            router.push('/login')
            return Promise.reject()
        }
        return response.status === 200 ? Promise.resolve(data) : Promise.reject(data)
    },
    // 服务器状态码不是200的情况
    error => {
        if (!isDebug){
        	//console.warn('响应拦截->error', error);
        }
        notification.error({message: '服务器异常'});
        return Promise.reject(error.response)
    }
);

export default instance
